module.exports = __webpack_public_path__ + "img/tintuc5.8665d881.png";